import { render, staticRenderFns } from "./DialogAddRevenueStream.vue?vue&type=template&id=08b10569&scoped=true"
import script from "./DialogAddRevenueStream.vue?vue&type=script&lang=js"
export * from "./DialogAddRevenueStream.vue?vue&type=script&lang=js"
import style0 from "./DialogAddRevenueStream.vue?vue&type=style&index=0&id=08b10569&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b10569",
  null
  
)

export default component.exports